import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': {
      marginRight: '0px',
    },
  },
  dialogPaper: {
    overflow: 'visible',
    margin: 'auto',
  },
  dialogContent: {
    overflow: 'visible',
  },
  formLabel: {
    marginBottom: '4px',
    fontSize: '16px',
    fontWeight: foundations.typography.fontWeight.medium,
  },
  textField: {
    width: '100%',
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      margin: 0,
    },
  },
  deleteBanner: {
    marginBottom: '16px',
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  radioButton: {
    alignItems: 'flex-start',
    '& input[type="radio"]': {
      display: 'none',
    },
  },
  formItem: {
    marginBottom: '16px',
  },
  errorMsg: {
    marginTop: '8px',
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px',
  },
});
